import { DemoMenuIcon, FaqMenuIcon, FeaturesMenuIcon } from "../../../assets/icons";
import styles from "./LandingPageMenu.module.scss";

interface LandingPageMenuProps {
    variant? : 'default' | 'secondary',
	scrollToSection: (ref: React.RefObject<HTMLDivElement>) => void;
	featuresRef: React.RefObject<HTMLDivElement>;
	demoRef: React.RefObject<HTMLDivElement>;
	faqsRef: React.RefObject<HTMLDivElement>;

}
export const LandingPageMenu = ({ variant = "default", scrollToSection, featuresRef, demoRef, faqsRef }: LandingPageMenuProps) => {
	const menuItemClass = `${styles.menuItem} ${styles[variant]}`;
	
	return (
		<div className={styles.menuContainer}>
			<button className={menuItemClass} onClick={() => scrollToSection(featuresRef)}>
				<FeaturesMenuIcon className={styles.icon} />
				<span>Features</span>
			</button>
			<button className={menuItemClass} onClick={() => scrollToSection(demoRef)}>
				<DemoMenuIcon className={styles.icon} />
				<span>Demo</span>
			</button>
			<button className={menuItemClass} onClick={() => scrollToSection(faqsRef)}>
				<FaqMenuIcon className={styles.icon} />
				<span>FAQs</span>
			</button>
		</div>
	);
};
